const base = 0.5

export const space = (...args) => {
  return args.map(a => `${a * base}rem`).join(' ')
}

export const unit = (...args) => {
  return args.map(a => `${a * base * 8}rem`).join(' ')
}
